// extracted by mini-css-extract-plugin
module.exports = {"customGrid":"custom-grid_customGrid__2PMDH","autoColumn":"custom-grid_autoColumn__1lGpv"};